import { put, select } from 'core/middlewares/utilities';
import { user, utilities } from 'core/use-cases';
import { getLocationPathname, setCustomAttribute } from 'core/utilities';
import { history } from 'core/use-cases/utilities';
import { getHomepageRoute } from './getters/getters';
import config from 'config';
import { BUSINESS_UNITS } from 'core/domains';
import { RootState } from 'core/store';

/**
 * Orchestrate the application initialization flow
 *
 */
export function* appInit(action: utilities.ActionSuccess) {
  const isEud = config.app.short === BUSINESS_UNITS.EUD.toLowerCase();
  const { payload } = action;

  const { isResaleIntention, isAutoStartEnabled }: RootState['user']['data'] = yield select(
    (rootState: RootState) => rootState.user.data,
  );

  if (payload) {
    setCustomAttribute('isExtendedCapitation', payload?.isExtendedCapitation || false, true);
    setCustomAttribute('isMultiBrand', payload?.isMultiBrand || false, true);
    setCustomAttribute('isAutoStartEnabled', isAutoStartEnabled || false, true);
    setCustomAttribute('isResaleIntention', isResaleIntention || false, true);
    setCustomAttribute('isCeased', payload?.isCeased || false, true);
    setCustomAttribute('isBlocked', payload?.isBlocked || false, true);
    setCustomAttribute('resellerId', payload?.resellerId || 0, true);
  }

  if (isEud && payload?.isMultiBrand) {
    history.push('/revendedores-grupoboticario');
    return;
  }

  if (payload?.isBlocked) {
    if (isEud && payload?.isMultiBrand) {
      history.push('/revendedores-grupoboticario');
      return;
    }
    history.push('/403');
    return;
  }

  yield put(user.actions.incentiveCampaignsListFetch.request());

  const currentPath = getLocationPathname();

  if (localStorage.getItem('is-ir') && currentPath === '/') {
    const homePage: string = yield getHomepageRoute();
    history.push(homePage);
    return;
  }

  yield put(user.actions.cyclesFetch.request());
}
